import { toast } from 'sonner';

export function manageError(error: unknown, contextMessage: string): void {
  console.error(`${contextMessage}:`, error);
  toast.error(`${contextMessage}`);
}
